import { faBadgeCheck } from '~/assets';
import { SceneWrapper } from '~/components';
import { observer } from '~/modules';
import { ContentContainer, Description, IconComponent, Title } from './styles';

const CreditSimulationConfirmation: React.FC = () => {
  return (
    <SceneWrapper>
      <ContentContainer>
        <IconComponent icon={faBadgeCheck} />
        <Title>Pedido realizado com sucesso. Aguarde o processamento.</Title>
        <Description>
          Assim que o crédito for confirmado a transferência será realizada.
          Essa transação pode levar algumas horas.
        </Description>
      </ContentContainer>
    </SceneWrapper>
  );
};

export default observer(CreditSimulationConfirmation);
